import { render, staticRenderFns } from "./classAmend.vue?vue&type=template&id=568547be&scoped=true&"
import script from "./classAmend.vue?vue&type=script&lang=js&"
export * from "./classAmend.vue?vue&type=script&lang=js&"
import style0 from "./classAmend.vue?vue&type=style&index=0&id=568547be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568547be",
  null
  
)

export default component.exports